import React, { FormEvent } from "react";
import { api, CompanyEmployeeRoleDto } from "shared/api";
import { formatDate, useApiMethod, UseModalProps } from "shared/lib";
import { Entity, Error, LoadingDots, Modal } from "shared/ui";

export interface IRoleDuplicateModal extends UseModalProps {
  companySlug: string;
  data: CompanyEmployeeRoleDto;
}

export const RoleDuplicateModal = (props: IRoleDuplicateModal) => {
  const submit = useApiMethod(api.companyRbac.companyEmployeeRoleCreate);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();

    await submit.call(props.companySlug, {
      name: props.data.name + " (2)",
      permissions: props.data.permissions,
    });

    await props.onSuccess();
  };

  return (
    <Modal onClose={props.close} width={400}>
      <form onSubmit={onSubmit}>
        <Modal.Header>
          <Modal.Title>Дублирование роли</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Entity>
            <Entity.Field title={props.data.name} />
            <Entity.Field right description={<>Создана {formatDate(props.data.createdAt, { month: "long" })}</>} />
          </Entity>

          {submit.error && <Error style={{ marginTop: 24 }}>{submit.error.message}</Error>}
        </Modal.Body>

        <Modal.Actions>
          <Modal.Action htmlType="button" onClick={props.close}>
            Назад
          </Modal.Action>

          <Modal.Action htmlType="submit" disabled={submit.loading}>
            {!submit.loading ? "Дублировать" : <LoadingDots size={4}>Дублируем</LoadingDots>}
          </Modal.Action>
        </Modal.Actions>
      </form>
    </Modal>
  );
};

RoleDuplicateModal.defaultProps = {};
